import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { RouterWrapperProps } from '../types';

const theme = {
  colors: {
    primary: '#1766FF',
    accent: '#0C5CDE',
    text: '#000000',
    background: '#FFFFFF',
    footerBg: '#F5F5F5',
  },
  fonts: {
    body: "'Barlow', sans-serif",
  },
};

export default function RouterWrapper({ children }: RouterWrapperProps) {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </BrowserRouter>
  );
}
